<template>
  <form-wrapper>
    <b-form @submit="submit">
      <h2 class="text-center">
        Add a new member
      </h2>

      <b-form-group>
        <label for="email-input">Email - we will send an invitation to this address</label>
        <b-form-input
          v-validate="'required|email'"
          id="email-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('email') || apiErrors.email.length }"
          :rows="3"
          :max-rows="6"
          :value="fields.email"
          type="text"
          name="email"
          @input="setEmail"/>
        <validation-errors :validation-errors="[errors.first('email')]"/>
        <validation-errors v-if="!errors.has('email')" :validation-errors="apiErrors.email"/>
      </b-form-group>

      <b-form-group>
        <label for="role-input">Role</label>
        <b-form-select
          id="role-input"
          :options="roleOptions"
          :disabled="saving"
          v-model="defaultRole"
          @change="setRole"/>
      </b-form-group>

      <relate-modules
        ref="relateModules"
        :initial-modules="[]"
        :disabled="saving"
        namespace="members"/>

      <relate-groups
        ref="relateGroups"
        :initial-groups="[]"
        :disabled="saving"
        namespace="members"/>

      <b-form-group class="form-buttons">
        <b-button :disabled="disabled" type="submit" variant="primary">
          Confirm
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>

      <form-success :success="success" class="form-alert">
        Member Added!
      </form-success>
    </b-form>

  </form-wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import relateModules from '../modules/relateModules'
import relateGroups from '../groups/relateGroups'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    formSuccess,
    formWrapper,
    relateModules,
    relateGroups,
    validationErrors
  },
  data () {
    return {
      roleOptions: [
        { text: 'user', value: 'user' },
        { text: 'admin', value: 'admin' },
        { text: 'master', value: 'master' }
      ],
      defaultRole: 'user'
    }
  },
  computed: {
    ...mapState('members/forms/store', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.resetFields()
      }
    }
  },
  methods: {
    ...mapActions({
      storeMember: 'members/store'
    }),
    submit (event) {
      event.preventDefault()

      // save the default role to the store
      if (!this.fields.role) {
        this.setRole(this.defaultRole)
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.storeMember()
        }
      })
    },
    setEmail (event) {
      this.$store.commit('members/forms/store/setField', {
        field: 'email',
        value: event
      })
    },
    setRole (event) {
      this.$store.commit('members/forms/store/setField', {
        field: 'role',
        value: event
      })
    },
    reset (event) {
      this.errors.clear()
      this.defaultRole = 'user'
      this.$refs.relateModules.reset()
      this.$refs.relateGroups.reset()
    },
    resetFields (event) {
      this.reset()
      this.$store.commit('members/forms/store/resetFields')
    },
    resetForm (event) {
      this.reset()
      this.$store.commit('members/forms/store/resetState')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/members/add.vue